import React, {createContext, useContext, useEffect, useState} from "react"
import TourLib from "@/constants/tourLib";
import {useUser} from "@/context/UserProvider";
import {APIGet, APIPut} from "@api";

const {REACT_APP_API_URL} = process.env

const TourContext = createContext<any>(null)
export const useTour = () => useContext(TourContext)

export default function TourContextProvider(props: any) {

    const {homeTourSteps} = TourLib()
    const {user, token} = useUser()

    const [tours, setTours] = useState<any>(null)
    const [homeTour, setHomeTour] = useState<number>(0)

    useEffect(() => {
        if (!!user) fetchTours()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        if (!!tours) {
            let pt = tours.find((tour: any) => tour.service_name === "packaging")
            if (!pt.done) setHomeTour(1)
        }
    }, [tours]);

    const fetchTours = () => {
        APIGet(REACT_APP_API_URL + "/user/setting", token).then((res: any) => {
            setTours(res.parsedBody.tours)
        })
    }

    const handleEndTour = () => {
        let body: any = {service_name: "packaging", done: true}
        APIPut(REACT_APP_API_URL + "/user/tour", body, token).then()
    }

    const resetTour = () => {
        let body: any = {service_name: "packaging", done: false}
        APIPut(REACT_APP_API_URL + "/user/tour", body, token).then()
    }

    return (
        <>
            <TourContext.Provider
                value={{
                    useTour,
                    handleEndTour, resetTour,
                    homeTour, setHomeTour, homeTourSteps
                }}
            >
                {props.children}
            </TourContext.Provider>
        </>
    )
}